import { Consent } from '@/shared/store/cookieConsent';

export interface Interface {
  require: boolean
  consent: Consent[]
  gdpr: boolean
}

export default window.Zire.cookieConsent!;
